import { centerModalOption } from '@psl/appComponents/ModalWrapper';
import { useLoading } from '@psl/components/LoadingIndicator/LoadingIndicator';
import { currentUserId } from '@psl/functions/auth/utils';
import { isDebugEnabled } from '@psl/functions/debugging';
import { auth } from '@psl/functions/firebase/firebaseAccess';
import { useAppModalNavigation } from '@psl/functions/navigation/utils/routeHelpers';
import { wrapNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { useServiceFactory } from '@psl/functions/services';
import { showAlert } from '@psl/functions/ux/showAlert';
import { makeDebug } from '@psl/utils/makeDebug';
import { useRoute } from '@react-navigation/native';
import { useEffect } from 'react';

const debug = makeDebug('user:slacklogin', isDebugEnabled('admin'));

export const SlackLoginPage = wrapNavigatorScreen(() => {
  const params = useRoute().params as any;
  const uuid = params?.uuid;
  const { storeService } = useServiceFactory();
  const navigation = useAppModalNavigation();
  const loading = useLoading();

  useEffect(() => {
    if (!uuid) {
      alert('Invalid request!');
      navigation.goBack();
      return;
    }
    debug('begin slack login with feedback id: %s', uuid);
    loading.show();
    storeService
      .storeApiControllerValidateFeedbackID({
        validateFeedbackIDRequest: {
          feedbackId: uuid,
        },
      })
      .then(res => {
        debug('validate feedback id response: %o', res);
        return auth.signInWithCustomToken(res.customToken);
      })
      .then(res => {
        debug('sign in with custom token successful: %o', res);
        return res;
      })
      .catch(err => {
        console.error(err);
        void showAlert('Oops!', 'The link you clicked is invalid.');
      })
      .finally(() => {
        loading.hide();
        if (currentUserId() == null) return;
        navigation.replace('home', {} as any);
      });
  }, [loading, navigation, storeService, uuid]);
  return null;
}, centerModalOption);
